package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.compose.painterResource

@Composable
fun ResourceIcon(
    imageResource: ImageResource,
    modifier: Modifier = Modifier,
    contentDescription: String? = null,
    tint: Color = LocalContentColor.current, //.copy(alpha = LocalContentAlpha.current),
) {
    val painter = painterResource(imageResource = imageResource)
    Icon(
        modifier = modifier,
        painter = painter,
        contentDescription = contentDescription,
        tint = tint,
    )
}

@Composable
fun ResourceIconWithoutTint(
    imageResource: ImageResource,
    modifier: Modifier = Modifier,
    contentDescription: String? = null,
) {
    ResourceIcon(
        modifier = modifier,
        imageResource = imageResource,
        contentDescription = contentDescription,
        tint = Color.Unspecified
    )
}
